import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-box content-box--chat p-0" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "chat-content w-100" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "chat-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Notes", -1)
const _hoisted_7 = { class: "count" }
const _hoisted_8 = { class: "chat-inner" }
const _hoisted_9 = { class: "chat-toolbar" }
const _hoisted_10 = { class: "chat-toolbar-wrapper" }
const _hoisted_11 = { class: "chat-toolbar--button-icon" }
const _hoisted_12 = {
  key: 0,
  class: "chat-toolbar--button-indicator"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "chat-toolbar--button-text" }, "Notes", -1)
const _hoisted_14 = { class: "chat-toolbar--button-icon" }
const _hoisted_15 = {
  key: 0,
  class: "chat-toolbar--button-indicator"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "chat-toolbar--button-text" }, "On Hold", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chat = _resolveComponent("Chat")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_Indicator = _resolveComponent("Indicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(!_ctx.hold ? _ctx.notesTotal : _ctx.holdNotesTotal), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in",
              duration: 200
            }, {
              default: _withCtx(() => [
                (!_ctx.hold)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 0,
                      "messages-list": _ctx.mappedNotesData,
                      onSubmit: _ctx.createNote
                    }, null, 8, ["messages-list", "onSubmit"]))
                  : (_openBlock(), _createBlock(_component_Chat, {
                      key: 1,
                      "messages-list": _ctx.mappedHoldNotesData,
                      "empty-icon": "onHold",
                      onSubmit: _ctx.createNote
                    }, null, 8, ["messages-list", "onSubmit"]))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: _normalizeClass(
              `chat-toolbar--button w-100 d-flex justify-content-center flex-column align-items-center ${
                !_ctx.hold ? 'active' : ''
              }`
            ),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hold = false))
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_svg_icon, { icon: "notes" }),
              (_ctx.hold)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createVNode(_component_Indicator, { count: _ctx.notesTotal }, null, 8, ["count"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_13
          ], 2),
          _createElementVNode("button", {
            class: _normalizeClass(
              `chat-toolbar--button w-100 d-flex justify-content-center flex-column align-items-center ${
                _ctx.hold ? 'active' : ''
              }`
            ),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hold = true))
          }, [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_svg_icon, { icon: "onHold" }),
              (!_ctx.hold)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _createVNode(_component_Indicator, { count: _ctx.holdNotesTotal }, null, 8, ["count"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_16
          ], 2)
        ])
      ])
    ])
  ]))
}